import CustomBridge from '../controllers/bridge/CustomBridge';
import { normalizeLink } from '../utils/url/normalizeLink';
import { useRequests } from '../redux/reducer/requests';

export const useOpen = () => {
  const {
    appInfoData: { baseUrl },
  } = useRequests();

  return (href) => {
    const newHref = normalizeLink(href, baseUrl);

    if (window.top !== window.self) CustomBridge.instance.send({ name: 'OPEN', type: 0, data: { url: newHref } });
    else window.open(newHref, '_blank');
  };
};
